import { useQuery } from '@tanstack/react-query';
import { isMocked } from '@/config/featureFlags';
import { getComingUpEvents } from '@/mocks/fixtures/events';
import { fetchUpcomingEvents } from '@/services/eventsCatalogService';
import type { ComingUpEvent } from '@/types/registeredStudent';

interface UseUpcomingEventsParams {
  subject?: string | null;
  gradeBand?: string | null;
  curriculum?: string | null;
}

export function useUpcomingEvents({ subject, gradeBand, curriculum }: UseUpcomingEventsParams = {}) {
  const useMock = isMocked('EVENTS');

  const query = useQuery<ComingUpEvent[]>({
    queryKey: ['upcomingEvents', subject, gradeBand, curriculum, useMock],
    queryFn: async () => {
      if (useMock) {
        const all = getComingUpEvents();
        return all.filter((e) => {
          const subjOk = !subject || e.subjectTags.length === 0 || e.subjectTags.some((t) => t.toLowerCase() === subject.toLowerCase());
          const gradeOk = !gradeBand || e.gradeBands.length === 0 || e.gradeBands.includes(gradeBand);
          const currOk = !curriculum || e.curriculumTags.length === 0 || e.curriculumTags.includes(curriculum);
          return subjOk && gradeOk && currOk;
        });
      }
      return fetchUpcomingEvents({ subject, gradeBand, curriculum });
    },
    staleTime: 5 * 60 * 1000,
  });

  return {
    events: query.data ?? [],
    isLoading: query.isLoading,
  };
}
